import { Component, OnInit, ViewEncapsulation, OnDestroy, Output, EventEmitter } from '@angular/core';
import { Subscription } from 'rxjs';
import { GlobalsService } from '@app/cp/shared/services/globals.service';
import { SearchTarget } from '@app/cp/shared/enums/SearchTarget';
import { ControlType } from '@app/cp/shared/enums/ControlTypes';
import { DQOIService } from '@app/cp/shared/services/DQOI.service';
import { DQOISearchEvent } from '@app/cp/shared/models/DQOISearchEvent';
import { CommonFunctions } from '@app/cp/shared/static/common-functions';

@Component({
  selector: 'construction-search',
    templateUrl: './construction-search.component.html',
    styleUrls: ['./construction-search.component.scss'],
    encapsulation: ViewEncapsulation.None
})
export class ConstructionSearchComponent implements OnInit, OnDestroy {
    searchTarget: SearchTarget = SearchTarget.contract;
    controlType: ControlType = ControlType.autoComplete;
    subs_dataSearchEvent: Subscription;
    @Output() selected: EventEmitter<any> = new EventEmitter<any>();

    constructor(globals: GlobalsService, private svc_dqoi: DQOIService) {

        this.subs_dataSearchEvent = this.svc_dqoi.searchEvent$.subscribe((data: DQOISearchEvent) => {

            if (data !== null) {
                this.searchExpanded = false;
            }
        });

    }
    searchExpanded: boolean = false;
    ngOnInit() {

    }
    ngOnDestroy() {
        CommonFunctions.unsubscribe(this.subs_dataSearchEvent);
    }
    searchSel(e: any) {
        this.selected.emit(e);

    }
    searchTargetChanged(e: SearchTarget) {
        this.searchTarget = e;
    }

}
